/**
 * Função utilitária para verificar se o usuário tem permissões de super ou admin
 */
export const isSuperOrAdmin = (user) => {
  if (!user) return false;
  
  // Verificar se é super user através do campo super
  if (user.super === true) return true;
  
  // Verificar se tem profile admin
  if (user.profile === "admin") return true;
  
  // Verificar roles específicas: super, admin
  if (user.roles && Array.isArray(user.roles)) {
    return user.roles.some(role => 
      role.role === "super" || role.role === "admin"
    );
  }
  
  return false;
};

export default isSuperOrAdmin;